export const CONTRACTING_OPEN_MODAL = 'CONTRACTING_OPEN_MODAL';
export const CONTRACTING_IN_PROGRESS = 'CONTRACTING_IN_PROGRESS';
export const CONTRACTING_CLOSE_MODAL = 'CONTRACTING_CLOSE_MODAL';
export const CONTRACTING_EVENT_RECEIVED = 'CONTRACTING_EVENT_RECEIVED';
export const CONTRACTING_TIMEOUT_FAILURE = 'CONTRACTING_TIMEOUT_FAILURE';
export const CONTRACTING_VERIFY_SUCCESS_EVENT = 'CONTRACTING_VERIFY_SUCCESS';
export const CONTRACTING_CANCEL_FAILURE_EVENT = 'CONTRACTING_CANCEL_FAILURE';
export const CONTRACTING_START_FAILURE_EVENT = 'CONTRACTING_START_FAILURE';
export const CONTRACTING_VERIFY_FAILURE_EVENT = 'CONTRACTING_VERIFY_FAILURE';
export const CONTRACTING_SAVED_WITH_ERRORS_EVENT = 'CONTRACTING_SAVED_WITH_ERRORS';
export const CONTRACTING_OFFER_SAVE_FAILURE_EVENT = 'CONTRACTING_OFFER_SAVE_FAILURE';
export const CONTRACTING_OFFER_SAVE_SUCCESS_EVENT = 'CONTRACTING_OFFER_SAVE_SUCCESS';
export const CONTRACTING_STAGE_CANCEL_REQUEST_FAILURE_EVENT = 'CONTRACTING_STAGE_CANCEL_REQUEST_FAILURE_EVENT';
export const CONTRACTING_STAGE_START_REQUEST_FAILURE_EVENT = 'CONTRACTING_STAGE_START_REQUEST_FAILURE_EVENT';
export const CONTRACTING_STAGE_VERIFY_REQUEST_FAILURE_EVENT = 'CONTRACTING_STAGE_VERIFY_REQUEST_FAILURE_EVENT';
export const CONTRACTING_STAGE_COPY_REQUEST_FAILURE_EVENT = 'CONTRACTING_STAGE_COPY_REQUEST_FAILURE_EVENT';
export const CONTRACTING_SAVE_FAILED_WITH_SPOT_ERRORS = 'CONTRACTING_SAVE_FAILED_WITH_SPOT_ERRORS';

export const CONTRACTING_STAGE_CANCEL_REQUEST = 'CONTRACTING_STAGE_CANCEL_REQUEST';
export const CONTRACTING_STAGE_CANCEL_SUCCESS = 'CONTRACTING_STAGE_CANCEL_SUCCESS';
export const CONTRACTING_STAGE_CANCEL_FAILURE = 'CONTRACTING_STAGE_CANCEL_FAILURE';

export const CONTRACTING_STAGE_COPY_AWAITING_CANCEL = 'CONTRACTING_STAGE_COPY_AWAITING_CANCEL';
export const CONTRACTING_STAGE_COPY_REQUEST = 'CONTRACTING_STAGE_COPY_REQUEST';
export const CONTRACTING_STAGE_COPY_SUCCESS = 'CONTRACTING_STAGE_COPY_SUCCESS';
export const CONTRACTING_STAGE_COPY_FAILURE = 'CONTRACTING_STAGE_COPY_FAILURE';
export const COPY_CREDIT_APP_EVENT_RECEIVED = 'COPY_CREDIT_APP_EVENT_RECEIVED';
export const COPY_CREDIT_APP_HTTP_ACK = 'COPY_CREDIT_APP_HTTP_ACK';
export const COPY_CREDIT_APP_HTTP_FAILURE = 'COPY_CREDIT_APP_HTTP_FAILURE';

export const COPY_CREDIT_APP_DEAL_UPDATE_REQUEST = 'COPY_CREDIT_APP_DEAL_UPDATE_REQUEST';
export const COPY_CREDIT_APP_DEAL_UPDATE_SUCCESS = 'COPY_CREDIT_APP_DEAL_UPDATE_SUCCESS';
export const COPY_CREDIT_APP_DEAL_UPDATE_FAILURE = 'COPY_CREDIT_APP_DEAL_UPDATE_FAILURE';

export const CONTRACTING_STAGE_START_REQUEST = 'CONTRACTING_STAGE_START_REQUEST';
export const CONTRACTING_STAGE_START_SUCCESS = 'CONTRACTING_STAGE_START_SUCCESS';
export const CONTRACTING_STAGE_START_FAILURE = 'CONTRACTING_STAGE_START_FAILURE';

export const CONTRACTING_STAGE_VERIFY_REQUEST = 'CONTRACTING_STAGE_VERIFY_REQUEST';
export const CONTRACTING_STAGE_VERIFY_SUCCESS = 'CONTRACTING_STAGE_VERIFY_SUCCESS';
export const CONTRACTING_STAGE_VERIFY_FAILURE = 'CONTRACTING_STAGE_VERIFY_FAILURE';
export const SET_CONTRACT_VALIDATION_ERRORS = 'SET_CONTRACT_VALIDATION_ERRORS';
export const CONTRACTING_GENERATE_CLICKED = 'CONTRACTING_GENERATE_CLICKED';
export const CONTRACTING_SET_FORM_CONTRACT_TYPE = 'CONTRACTING_SET_FORM_CONTRACT_TYPE';
export const SET_FIRST_CONTRACT_API_ERRORED_VPP = 'SET_CONTRACT_API_ERRORED_VPP_PRODUCT';

export const CONTRACTING_WAITING_FOR_FS = 'CONTRACTING_WAITING_FOR_FS';
export const CONTRACTING_FS_RESPONSE_RECEIVED = 'CONTRACTING_FS_RESPONSE_RECEIVED';
export const SET_CONTRACT_VALIDATION_LOADING = 'SET_CONTRACT_VALIDATION_LOADING';

export const CONTRACTING_STATUS_REQUEST = 'CONTRACTING_STATUS_REQUEST';
export const CONTRACTING_STATUS_SUCCESS = 'CONTRACTING_STATUS_SUCCESS';
export const CONTRACTING_STATUS_FAILURE = 'CONTRACTING_STATUS_FAILURE';
